import loadable from "@loadable/component";

export const Templates = {
	UniversityLayout: loadable(() => import("./university/GenericTemplate")),
	LeadLayout: loadable(() => import("./university/LeadTemplate")),
	NotFound: loadable(() => import("./university/404")),
	ExperienceLayout: loadable(() => import("./university/ExperienceTemplate")),
	BlogLayout: loadable(() => import("./university/BlogTemplate")),
	RebrandBlogIndexLayout: loadable(
		() => import("./university/RebrandBlogIndexTemplate"),
	),
	RebrandBlogPageLayout: loadable(
		() => import("./university/RebrandBlogPageTemplate"),
	),
};
